var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "invoice_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#invoice_svg__a)",
    fill: "#12385C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 21.5c-.7 0-1.292-.242-1.775-.725C2.742 20.292 2.5 19.7 2.5 19v-1.6c0-.25.088-.463.263-.638A.867.867 0 013.4 16.5h2.1v-12a1 1 0 011-1h12a1 1 0 011 1V19c0 .7-.242 1.292-.725 1.775-.483.483-1.075.725-1.775.725H5zM17 20c.283 0 .52-.096.712-.288A.965.965 0 0018 19V5H7v11.5h8.1a.87.87 0 01.638.262.87.87 0 01.262.638V19c0 .283.096.52.288.712A.965.965 0 0017 20zM5 20h9.5v-2H4v1c0 .283.096.52.287.712.192.192.43.288.713.288z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.375 12.275l-1.575-1.6a.993.993 0 00-.25-.15.7.7 0 00-.262-.05.91.91 0 00-.288.05.627.627 0 00-.25.15c-.167.166-.25.35-.25.55 0 .2.083.375.25.525l2.025 2.05c.083.1.18.166.288.2a1.137 1.137 0 00.675 0 .605.605 0 00.287-.2l4.125-4.125c.15-.15.23-.33.238-.538a.734.734 0 00-.238-.562.733.733 0 00-.537-.225.734.734 0 00-.538.225l-3.7 3.7z"
  }))));
}
export default SvgInvoice;